/* eslint-disable no-plusplus */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { Analytics } from '@garmin/support-analytics';
import store from '../app/store/store';
import Config from '../config/api';
import LocalStorageUtils from './localStorageUtils';

class Utils {
  /**
   * Add a class to element
   * @param el {object} element
   * @param className {string} name of class to add
   */
  static addClass(el, className) {
    if (el) {
      if (typeof el.classList === 'undefined') {
        // eslint-disable-next-line no-undef
        _.each(el, (indivEl) => {
          this._addClass(indivEl, className);
        });
      } else {
        this._addClass(el, className);
      }
    }
  }

  // eslint-disable-next-line no-underscore-dangle
  static _addClass(el, className) {
    if (this.isDefined(el) && el.classList) {
      el.classList.add(className);
    }
  }

  /**
   * Remove a class to element
   * @param el {object} element
   * @param className {string} name of class to remove
   */
  static removeClass(el, className) {
    if (el) {
      if (typeof el.classList === 'undefined') {
        // eslint-disable-next-line no-undef
        _.each(el, (indivEl) => {
          this._removeClass(indivEl, className);
        });
      } else {
        this._removeClass(el, className);
      }
    }
  }

  static _removeClass(el, className) {
    if (this.isDefined(el) && el.classList) {
      el.classList.remove(className);
    }
  }

  /**
   * Strip HTML from a string
   * NOTE: There is an excellent NPM package called striptags which will
   * do this in a much better fashion. It is not compatible with the current configuration
   * of this project and should be pulled in at a later time.
   */
  static stripTags(input) {
    const output = input.replace(/<(?:.|\n)*?>/gm, '');
    return output;
  }

  /**
   * Is defined
   * Determines if a given value is defined
   * @param value
   * @returns {boolean}
   */
  static isDefined(value) {
    if (typeof value !== 'undefined') {
      return true;
    }
    return false;
  }

  /**
     * Set product registration timestamp for a given product ID to local
     * storage.
     */
  static setProductRegistrationTimestamp() {
    let currentRegistrationData;
    try {
      currentRegistrationData = LocalStorageUtils.getLocalStorageValue('registrations');
    } catch (e) {
      currentRegistrationData = false;
    }

    let productRegistrationData;
    let updatedRegistrationData;
    const urlParams = this.getObjectCopy(store.getters.urlParams);

    if (urlParams.productID && (urlParams.utm_source || urlParams.referrer)) {
      if (currentRegistrationData && currentRegistrationData.length > 0) {
        updatedRegistrationData = JSON.parse(currentRegistrationData);
      } else {
        updatedRegistrationData = [];
      }

      for (let i = 0; i < updatedRegistrationData.length; i++) {
        if (updatedRegistrationData[i].productID === urlParams.productID) {
          updatedRegistrationData.splice(i, 1);
        }
      }

      productRegistrationData = {
        productID: urlParams.productID,
        registrationTimestamp: Date.now(),
      };

      updatedRegistrationData.push(productRegistrationData);

      LocalStorageUtils.setLocalStorageValue('registrations', JSON.stringify(updatedRegistrationData));

      urlParams.tab = 'welcome';
      urlParams.referrer = false;
      urlParams.utm_source = false;

      store.commit('isWelcomeTabVisibleUpdate', true);
      store.commit('selectedTabUpdate', urlParams.tab);
      store.commit('urlParamsUpdate', urlParams);

      window.history.replaceState({ ...urlParams, current: '' }, null, this.formatUrlParametersObject(urlParams));
    }
  }

  /**
     * Determines if the product registration is active
     * @param {string} productID
     * @returns {boolean}
     */
  static isProductRegistrationActive(productID) {
    const registrations = LocalStorageUtils.getLocalStorageValue('registrations');
    let activeFlag = false;
    let registrationsArr;

    if (typeof productID !== 'undefined' && registrations) {
      registrationsArr = JSON.parse(registrations);

      if (Array.isArray(registrationsArr)) {
        for (let i = 0; i < registrationsArr.length; i++) {
          if (registrationsArr[i].productID === productID) {
            const registrationDate = registrationsArr[i].registrationTimestamp;
            const registrationDuration = Config.productRegistrationExpiration * 1000 * 60;
            const productRegistrationExpirationDate = registrationDate + registrationDuration;

            if (productRegistrationExpirationDate > Date.now()) {
              activeFlag = true;
            }

            break;
          }
        }
      }
    }

    return activeFlag;
  }

  static isURLSource(source, urlParams) {
    const urlSources = {
      referrer: 'registration',
      registration_email: 'registration',
    };

    if (
      typeof urlSources[source] !== 'undefined'
      && (urlParams.utm_source === urlSources[source]
        || urlParams.referrer === urlSources[source]
      )) {
      return true;
    }
    return false;
  }

  static triggerWelcomeLoadAnalytics(params) {
    if (this.isURLSource('registration_email', params) || this.isURLSource('referrer', params)) {
      const eventParams = Analytics.getAnalyticsEventParams('_welcome-tab-initialized');
      Analytics.trackAnalyticsEvent({
        manualAnalyticsEvent: eventParams,
        product_name: store.getters.product.displayName,
        page_type: 'Product - Welcome',
        link_type: 'Welcome Link',
      });
    }
  }

  static formatUrlParametersObject(params) {
    let formattedUrlParameters = '';
    params = this.getObjectCopy(params);
    params = this.removeObjectFalsey(params);
    Object.keys(params).forEach((param, index) => {
      if (index === 0) {
        formattedUrlParameters += '?';
      } else {
        formattedUrlParameters += '&';
      }
      formattedUrlParameters += `${param}=${encodeURIComponent(params[param])}`;
    });

    if (formattedUrlParameters.length === 0) {
      formattedUrlParameters = false;
    }

    return formattedUrlParameters;
  }

  static removeObjectFalsey(obj) {
    const paramsObj = obj;
    Object.keys(obj).forEach((p) => {
      if (obj[p] === null || obj[p] === false || typeof obj[p] === 'undefined') {
        delete paramsObj[p];
      }
    });
    return paramsObj;
  }

  static getLocale() {
    return window?.AppData?.locale || 'en-US';
  }

  static getObjectCopy(toCopy) {
    return { ...toCopy };
  }

  static isSasSourceParam(param) {
    return param === 'sas_source';
  }

  static getAnalyticsEventCategoryFromTabName(tabShortName) {
    if (store.getters.noProductFlowFlag) {
      return 'No Product - Support FAQ';
    }

    switch (tabShortName) {
      case 'topics':
        return 'Product - Support FAQ';
      case 'aviation-otc':
        return 'Consumer-AviationOTC';
      case 'welcome':
        return 'Product - Welcome - Support FAQ';
      case 'software':
        return 'Product Page - Software - Support FAQ';
      case 'repair':
        return 'Product - Repair - Support FAQ';
      default:
        return `Consumer-${tabShortName.charAt(0).toUpperCase()}${tabShortName.slice(1)}`;
    }
  }

  static onAltLocaleLinkClick(isNoResultsMessageActive) {
    const { urlParams } = store.getters;
    store.dispatch('updatePrevItemLink');
    urlParams.altLocaleSearchPrompt = false;

    if (store.getters.hasUserSearched && urlParams.altLocale) {
      urlParams.altLocale = false;
    } else {
      // eslint-disable-next-line max-len
      urlParams.altLocale = store.state.translations.supportCenterResultsPage.scSearchResults.alternateLocaleSearch.scAlternateLocaleSearch.alternateSearchLocale;
    }

    if (urlParams.altLocale && isNoResultsMessageActive) {
      urlParams.altLocaleSearchPrompt = true;
      urlParams.searchQuery = false;
      urlParams.topicTag = false;
    }

    store.dispatch('updateUrlParams', {
      params: urlParams,
      pushHistoryEntryFlag: true,
    });
    store.commit('routedComponentToRenderUpdate', 'topics');
  }

  static getDefaultLocale() {
    return 'en-US';
  }

  static getBaseUrl() {
    let baseUrl = '';
    if (!window.location.origin) {
      // eslint-disable-next-line max-len, no-multi-assign
      baseUrl = window.location.origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
    } else {
      baseUrl = window.location.origin;
    }

    return baseUrl;
  }

  static getI18nBaseUrl() {
    return `${this.getBaseUrl()}/${this.getLocale()}`;
  }
}

export default Utils;
